import { Box, BoxProps } from "@chakra-ui/react";
import { ReactNode } from "react";
import { CONTENT_WIDTH } from "../../../config";

interface Props extends BoxProps {
  children: ReactNode;
  fullWidth?: boolean;
}

export const PageContainer = ({ children, fullWidth = false, ...rest }: Props) => (
  <Box w="full" h="full" mx="auto" maxW={fullWidth ? "full" : CONTENT_WIDTH} {...rest}>
    {children}
  </Box>
);
